import './RequestLinkModal.css';

import { Button, Grid, TextField, Typography } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AppLoader from 'components/Loader';
import Modal from 'components/ModalWrapper';
import { TrackLinkRequest } from 'utilities/insights';
import { resetSendingLinkRequest } from 'redux/actions/feedback';
import { sendLinkRequest } from 'redux/thunks/feedback';
import swal from 'sweetalert2';
import { validURL } from 'utilities/Validations';

const RequestLinkModal = ({ show, onClose, siteId, dashboardId, owner_email }) => {
    const [message, set_message] = useState('');
    const [url, set_url] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});
    const email = useSelector((state) => state.user.email);
    const feedback = useSelector((state) => state.feedback);
    const dispatch = useDispatch();

    const close = useCallback(() => {
        set_message({ text: '', valid: false });
        set_url({ text: '', valid: false });
        onClose();
    }, [onClose]);

    const validate = () => {
        let errors = {};

        if (!message) {
            errors['message'] = '';
        }

        if (!url) {
            errors['url'] = 'This field is required';
        } else {
            const isValidUrl = validURL(url);

            if (!isValidUrl) {
                errors['url'] = 'Please enter a valid url';
            }
        }

        setFieldErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async () => {
        const content = {
            url: url,
            message: message,
            owner_email,
            dashboardId,
            siteId,
            sender_email: email ? email : 'Anonymous',
            messageType: 'LinkRequest',
        };

        if (!validate()) {
            return;
        }
        
        TrackLinkRequest(siteId, dashboardId, owner_email);
        dispatch(sendLinkRequest(content));
    };

    useEffect(() => {
        if (feedback.sendingLinkRequestSuccess) {
            swal.fire({
                type: 'success',
                title: 'Thank you',
                text: 'Thank you for your link request!',
                confirmButtonText: 'Ok',
            });
            close();
            dispatch(resetSendingLinkRequest());
        }
    }, [feedback.sendingLinkRequestSuccess, close, dispatch]);

    return (
        <Modal height='small' open={show} onCloseClicked={close}>
            <Grid container direction='column' className='request-link-modal'>
                <Grid container item justifyContent='center' className='request-link-modal__title'>
                    <Typography variant='h5'>Request a new link</Typography>
                </Grid>

                <Grid container direction='column' className='request-link-modal__body'>
                    {feedback.sendingLinkRequest ? (
                        <AppLoader />
                    ) : (
                        <>
                            <TextField
                                error={'url' in fieldErrors}
                                className='request-link-modal__form-field'
                                helperText={'url' in fieldErrors && fieldErrors['url']}
                                label='Url *'
                                variant='outlined'
                                value={url}
                                onChange={(event) => set_url(event.target.value)}
                            />

                            <TextField
                                className='request-link-modal__form-field'
                                error={'message' in fieldErrors}
                                helperText={'message' in fieldErrors && 'This field is required'}
                                rows={4}
                                multiline
                                variant='outlined'
                                label='Message *'
                                value={message.text}
                                onChange={(event) => set_message(event.target.value)}
                            />
                        </>
                    )}
                </Grid>

                <Grid container justifyContent='space-between' className='request-link-modal__footer'>
                    <Button className='request-link-modal__footer-button--cancel' variant='contained' color='default' onClick={() => close()} disabled={feedback.sendingLinkRequest}>
                        Cancel
                    </Button>
                    <Button
                        className='request-link-modal__footer-button--save'
                        variant='contained'
                        color='primary'
                        disabled={feedback.sendingLinkRequest}
                        onClick={handleSubmit}
                        style={{ marginLeft: '10px' }}
                    >
                        Send
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    );
};

export default RequestLinkModal;
